<template>
<div class="ArticleTG">
    <keep-alive include="articleList">
        <router-view></router-view>
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'ArticleTG',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
    },
    filters: {
    },
    watch: {},
    computed: {
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ArticleTG {
    height: 100%;
    // min-width: 1200px;
}
</style>